exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".audit-create[data-v-e6b7653a] .yxt-form-item__content{max-width:524px}\n", ""]);

